export default __webpack_public_path__ + "static/media/sportsbra-large-front-toosmall.b996c26b.jpg";